import { jwtService } from "services";
// import { setUserData } from "./user.actions";

export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_START = "LOGIN_START";

export const submitLogin = ({ UserName, AppType, onSuccess }) => {
  return (dispatch) => {
    dispatch({
      type: LOGIN_START,
    });
    jwtService
      .signInWithMobile({ UserName, AppType })
      .then((user) => {
        // dispatch(setUserData(user));
        onSuccess();
        return dispatch({
          type: LOGIN_SUCCESS,
          payload:
            process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
              ? user.Cellphone && user.Cellphone
              : "",
        });
      })
      .catch((error) => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error,
        });
      });
  };
};
